export const checkBrowser = () => {
  const userAgentString = navigator.userAgent;
  let chromeAgent = userAgentString.indexOf('Chrome') > -1;
  const IExplorerAgent =
    userAgentString.indexOf('MSIE') > -1 || userAgentString.indexOf('rv:') > -1;
  const firefoxAgent = userAgentString.indexOf('Firefox') > -1;
  let safariAgent = userAgentString.indexOf('Safari') > -1;
  if (chromeAgent && safariAgent) safariAgent = false;

  const operaAgent = userAgentString.indexOf('OP') > -1;
  if (chromeAgent && operaAgent) chromeAgent = false;

  return {
    safariAgent,
    chromeAgent,
    IExplorerAgent,
    operaAgent,
    firefoxAgent,
  };
};
